import React, { useEffect, useState } from 'react';
import { Form, Typography, message, Col, List, Row, Input } from 'antd';
import GenericModal from '../../../../../../components/buttons/genericModal';
import { backendDeleteWithoutRefresh } from '../../../../../../helpers/callBackend';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const { Text } = Typography;

const DeleteConnectionMulti = (props) => {
	const [submitting, setSubmitting] = useState(false);
	const [selectedRows, setSelectedRows] = useState(props.selectedRows || []);

	useEffect(() => {
		return () => {
			props.handleCancelModal();
		};
	}, []);

	const onFormSubmitModal = () => {
		setSubmitting(true);
		const hasAssignedRow = props.selectedRows.some(row => {
			if (row.isAssigned) {
				message.error(`${row.account} is assigned to a dashboard, it cannot be deleted`);
				return true;
			}
			return false;
		});
		if (hasAssignedRow) {
			return;
		}
		let data = { 'sourceAccountInfo': [] };
		props.selectedRows.forEach(row => {
			data.sourceAccountInfo.push({
				"source": row.source,
				"sourceAccountId": row.bankId,
			})
		});
		backendDeleteWithoutRefresh('/api/external-connections/', data)
			.then(() => {
				props.onSuccess(props.selectedRows);
				props.handleCancelModal();
			}).finally(() => setSubmitting(false));
	};

	const deleteRow = (bankAccountId) => {
		setSelectedRows((prevState) => {
			const newSelectedRows = prevState.filter((account) => {
				return account.key !== bankAccountId
			})
			return newSelectedRows;
		});
	}

	return (
		<GenericModal
			size='lg'
			visible={props.visible}
			handleCancelModal={() => props.handleCancelModal()}
			showModal={() => props.handleShowModal()}
			modalTitle="Delete Connections"
			modalBody={
				<Form
					layout="vertical"
					name="basic"
					onFinish={onFormSubmitModal}
					autoComplete="off"
				>

					<Row>
						Delete the following {selectedRows.length} connection(s). Note: you cannot delete any external connections that are assigned to your dashboard.

					</Row>

					<Row justify="center">
						<Col span={20}>
							<List
								itemLayout="horizontal"
								dataSource={selectedRows}
								renderItem={(item) => (
									<List.Item>
										<Col span={12}>{item.institution} / {item.account}</Col>
										<Col span={6}>
											{item.isAssigned ?
												<Typography.Text type="secondary" style={{ fontSize: '10px' }} italic>
													Assigned, please remove
												</Typography.Text>
												: <></>}
										</Col>
										<Col span={6} align="right">
											<Button sx={{ fontSize: 14, width: '100px', textTransform: 'none' }} disableElevation fullWidth size="small" variant="outlined" color="secondary" onClick={() => deleteRow(item.key)}>Remove</Button>
										</Col>
									</List.Item>
								)
								}
							/>
						</Col>
					</Row>
					<Row style={{ marginTop: "10px", marginBottom: "10px" }}>
						<Text strong>
							Please write "delete" below to proceed.
						</Text>
					</Row>
					<Form.Item
						name="deleteText"
						rules={[
							{
								validator: (_, value) =>
									value === 'delete'
										? Promise.resolve()
										: Promise.reject(new Error('Please write "delete"')),
							},
						]}
					>
						<Input />
					</Form.Item>
					<Form.Item>
						<LoadingButton
							htmlType="submit"
							loading={submitting}
							loadingPosition="start"
							sx={{ fontSize: 14, textTransform: 'none' }}
							disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
						>
							Submit
						</LoadingButton>

					</Form.Item>
				</Form>
			}
		/>
	);
};

export default DeleteConnectionMulti;

